export const commonButtonColors = [
    "inherit",
    "primary",
    "secondary",
    "default"
];
export function isButtonColor(color) {
    return commonButtonColors.includes(color);
}
export const commonButtonVariants = ["text", "outlined", "contained"];
export function isButtonVariant(variant) {
    return commonButtonVariants.includes(variant);
}
//# sourceMappingURL=ButtonCommon.js.map